import type { MultiStepFormData } from "@/stores";
import type { PatientCaseStatus } from "@/utils";
import type { ServiceResponse } from "../api.types";
import { privateAPI } from "../axios";
import { buildSubmitAllFormsRequest } from "./buildSubmitAllFormsRequest";

interface SubmitAllFormsResponse {
  patientId: string;
  transferId: string;
  date: string;
  status: Exclude<PatientCaseStatus, "new_patient">;
}

export const submitAllForms = async (body: MultiStepFormData) => {
  const transformedBody = buildSubmitAllFormsRequest(body);
  const { data } = await privateAPI.post<
    ServiceResponse<SubmitAllFormsResponse>
  >("/forms", {
    ...transformedBody,
  });
  return data.data;
};
